'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var formField = require('./form-field-568b9a9c.js');
require('./messages-f8f39369.js');
var dropdown = require('./dropdown-9156b270.js');

var StyledDropdown = styled__default(dropdown.Dropdown)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  div:first-child {\n    p {\n      padding-right: 40px;\n    }\n  }\n  .placeholder-option {\n    color: ", ";\n  }\n"], ["\n  div:first-child {\n    p {\n      padding-right: 40px;\n    }\n  }\n  .placeholder-option {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMediumAlt;
});
var Clear = styled__default.span(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  position: absolute;\n  right: 40px;\n  top: 50%;\n  margin-top: -12px;\n"], ["\n  color: ", ";\n  cursor: pointer;\n  position: absolute;\n  right: 40px;\n  top: 50%;\n  margin-top: -12px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var HqOSelectWrapper = function (_a) {
    var options = _a.options, placeholder = _a.placeholder, selectedLabel = _a.selectedLabel, isPortal = _a.isPortal, zIndexOverlay = _a.zIndexOverlay, disabled = _a.disabled, required = _a.required, value = _a.value, onSelect = _a.onSelect, handleClear = _a.handleClear, restProps = tslib_es6.__rest(_a, ["options", "placeholder", "selectedLabel", "isPortal", "zIndexOverlay", "disabled", "required", "value", "onSelect", "handleClear"]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledDropdown, tslib_es6.__assign({ onSelect: onSelect, options: options, placeholder: placeholder, value: selectedLabel, isPortal: isPortal, zIndexOverlay: zIndexOverlay, disabled: disabled }, restProps)),
        (!required && value) && (React__default.createElement(Clear, { className: "material-icons", onClick: handleClear, "data-testid": "select-clear-button" }, "clear"))));
};
var templateObject_1, templateObject_2;

var useSelectedOption = function (_a) {
    var options = _a.options, value = _a.value;
    var selectedOption = React.useMemo(function () { return (value ? options.find(function (option) { return option.value === value; }) : null); }, [options, value]);
    return selectedOption || null;
};

var useControls = function (_a) {
    var value = _a.value, options = _a.options, onSelect = _a.onSelect;
    var handleClear = React.useCallback(function () {
        onSelect({ value: null });
    }, [onSelect]);
    var selectedOption = useSelectedOption({ options: options, value: value });
    return {
        selectedLabel: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label,
        handleClear: handleClear,
    };
};

var HqOSelect = function (_a) {
    var options = _a.options, value = _a.value, onSelect = _a.onSelect, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'hqo-select' : _b, restProps = tslib_es6.__rest(_a, ["options", "value", "onSelect", "required", "disabled", "readOnly", "dataTestId"]);
    var _c = useControls({ options: options, value: value, onSelect: onSelect }), selectedLabel = _c.selectedLabel, handleClear = _c.handleClear;
    return (React__default.createElement(formField.FormField, tslib_es6.__assign({}, restProps, { readOnly: readOnly, required: required, disabled: disabled, value: selectedLabel, dataTestId: dataTestId, customComponent: readOnly ? null : (React__default.createElement(HqOSelectWrapper, tslib_es6.__assign({ options: options, selectedLabel: selectedLabel, disabled: disabled, required: required, value: value, onSelect: onSelect, handleClear: handleClear }, restProps))) })));
};

exports.HqOSelect = HqOSelect;
